import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface ChangeSchemaCoopConfig {
  isChangeSchemaCoopEnable: boolean;
}

export const changeSchemaCoopConfig: ChangeSchemaCoopConfig = {
  isChangeSchemaCoopEnable: environment.isChangeSchemaCoopEnable,
};

export const CHANGE_SCHEMA_COOP_CONFIG = new InjectionToken<ChangeSchemaCoopConfig>(
  'changeSchemaCoopConfig',
);
